import { useEffect } from "react";

import { useQuery } from "@hooks/useQuery";
import { PAYMENT_CALLBACK_COMPLETE } from "@types-runway/billing";
import { APP_URL, ENV } from "@utils/constantsEnv";

export const PaymentCallbackBridge = () => {
  const query = useQuery();
  // Capture the session ID from the URL if WithFlex sends it back
  // (Helpful for the parent to know WHICH invoice was paid)
  const sessionId = query.get("checkout_session_id") || query.get("session_id");

  useEffect(() => {
    // The specific message protocol
    const message = {
      type: PAYMENT_CALLBACK_COMPLETE,
      payload: {
        sessionId: sessionId,
        timestamp: Date.now(),
      },
    };

    // Shout to the parent window
    if (window.parent) {
      const origin = ENV === "development" ? "*" : APP_URL;
      window.parent.postMessage(message, origin);
    }
  }, [sessionId]);

  return (
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
    >
      <p>Finalizing payment...</p>
    </div>
  );
};
